/* Lockdown Security homepage hero: weather-smart feature (sections/lds-home-hero-wx.liquid).
   Reads Environment and Climate Change Canada's city forecast in the visitor's browser and swaps the
   feature panel to match the next morning. If anything fails, the feature as served (today's
   seasonal one) simply stays. The only thing sent to Environment Canada is the forecast city's id. */
(function () {
  'use strict';
  var API = 'https://api.weather.gc.ca/collections/citypageweather-realtime/items/';
  var CACHE_MS = 30 * 60 * 1000;
  var CITY_KEY = 'lds_wx_city';
  var SNOW = /snow|flurr/i;

  function store(key, val) {
    try {
      if (arguments.length < 2) return JSON.parse(window.localStorage.getItem(key));
      window.localStorage.setItem(key, JSON.stringify(val));
    } catch (e) {}
    return null;
  }
  function num(v) { var n = parseFloat(v); return isNaN(n) ? null : n; }
  function en(o) { return o && o.en != null ? o.en : null; }
  function deg(n) { n = Math.round(n); return (n < 0 ? '−' + Math.abs(n) : String(n)) + '°C'; }
  function km(lat1, lon1, lat2, lon2) {
    var r = Math.PI / 180, x = (lon2 - lon1) * r * Math.cos((lat1 + lat2) / 2 * r), y = (lat2 - lat1) * r;
    return Math.sqrt(x * x + y * y) * 6371;
  }

  /* Day and hour in Toronto time, so "7am" means 7am in the GTA whatever the visitor's clock says. */
  var fmt = null;
  try { fmt = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Toronto', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false }); } catch (e) {}
  function local(when) {
    var d = new Date(when), o = {};
    if (!fmt || isNaN(d.getTime())) return null;
    fmt.formatToParts(d).forEach(function (p) { o[p.type] = p.value; });
    return { day: o.year + o.month + o.day, hour: parseInt(o.hour, 10) % 24 };
  }

  /* One city's forecast, boiled down to what the hero needs. */
  function digest(feat) {
    var p = feat && feat.properties, now = local(Date.now());
    if (!p || !now) return null;
    var today = now.hour < 7; /* before 7am, the next 7am is this morning */
    var hours = (p.hourlyForecastGroup && p.hourlyForecastGroup.hourlyForecasts) || [];
    var seven = null, sevenDay = null, snow = false, i, l;
    for (i = 0; i < hours.length; i++) {
      l = local(hours[i].timestamp);
      if (!l || (l.day === now.day && !today)) continue;
      if (seven === null && l.hour === 7) { seven = hours[i]; sevenDay = l.day; }
      if (l.hour >= 5 && l.hour <= 9 && (sevenDay === null || l.day === sevenDay) && SNOW.test(en(hours[i].condition) || '')) snow = true;
    }
    /* Highs and lows by period: today's high (daytime only), tonight's low, then tomorrow's high. */
    var periods = (p.forecastGroup && p.forecastGroup.forecasts) || [], low = null, firstHigh = null, nextHigh = null;
    for (i = 0; i < periods.length && nextHigh === null; i++) {
      var temps = (periods[i].temperatures && periods[i].temperatures.temperature) || [];
      for (var k = 0; k < temps.length; k++) {
        var cls = en(temps[k]['class']), v = num(en(temps[k].value));
        if (v === null) continue;
        if (cls === 'low' && low === null) low = v;
        else if (cls === 'high' && low === null && firstHigh === null) firstHigh = v;
        else if (cls === 'high' && low !== null && nextHigh === null) nextHigh = v;
      }
      if (seven === null && low !== null && SNOW.test(en(periods[i].abbreviatedForecast && periods[i].abbreviatedForecast.textSummary) || '')) snow = true;
    }
    var t = seven ? num(en(seven.temperature && seven.temperature.value)) : low;
    if (t === null) return null;
    var feels = seven && seven.windChill ? num(en(seven.windChill.value)) : null;
    var c = feat.geometry && feat.geometry.coordinates;
    return {
      t7: t, feels: feels === null ? t : feels, snow: snow, today: today,
      high: today ? (firstHigh !== null ? firstHigh : nextHigh) : nextHigh,
      city: en(p.name) || '', lat: c ? c[1] : null, lon: c ? c[0] : null
    };
  }

  function getForecast(id) {
    var key = 'lds_wx_' + id, hit = store(key);
    if (hit && hit.f && Date.now() - hit.t < CACHE_MS) return Promise.resolve(hit.f);
    if (!window.fetch || !window.Promise) return Promise.reject(new Error('unsupported'));
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 5000);
    return fetch(API + encodeURIComponent(id) + '?f=json', ctl ? { signal: ctl.signal } : {})
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (j) {
        clearTimeout(timer);
        var f = digest(j);
        if (!f) throw new Error('no forecast');
        store(key, { t: Date.now(), f: f });
        return f;
      }, function (e) { clearTimeout(timer); throw e; });
  }

  function pickMode(f, cfg) {
    if (f.snow && f.t7 <= cfg.snowMax) return 'snow';
    if (f.t7 <= cfg.cold) return 'cold';
    if (f.high !== null && f.high >= cfg.hot) return 'hot';
    return 'mild';
  }

  var placesP = null;
  function places(url) {
    if (!placesP) {
      placesP = fetch(url).then(function (r) { return r.json(); }).then(function (txt) {
        return String(txt).split(';').map(function (row) {
          var p = row.split('|');
          return { id: p[0], name: p[1] || '', prov: p[0].split('-')[0].toUpperCase() };
        });
      });
      placesP.catch(function () { placesP = null; });
    }
    return placesP;
  }
  function plain(s) {
    s = String(s).toLowerCase();
    return s.normalize ? s.normalize('NFD').replace(/[̀-ͯ]/g, '') : s;
  }

  function init(root) {
    var cfg;
    try { cfg = JSON.parse(root.querySelector('[data-wx-config]').textContent); } catch (e) { return; }
    var q = function (s) { return root.querySelector(s); };
    var media = q('[data-wx-media]'), tag = q('[data-wx-tag]'), title = q('[data-wx-title]'),
      text = q('[data-wx-text]'), btn = q('[data-wx-btn]'), strip = q('[data-wx-strip]'),
      also = q('[data-wx-also]'), credit = q('[data-wx-credit]');
    if (!media || !tag || !title || !text || !btn) return;
    var served = { cls: media.className, tag: tag.textContent, title: title.textContent, text: text.textContent, btn: btn.textContent, href: btn.getAttribute('href') };
    var originalNodes = null; /* the served media (usually the video), kept so it isn't reloaded */
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function tpl(name) {
      var t = q('template[data-wx-tpl="' + name + '"]');
      return t ? document.importNode(t.content, true) : null;
    }
    function setMedia(kind) {
      var extras = media.querySelectorAll('[data-wx-extra]');
      for (var i = 0; i < extras.length; i++) extras[i].parentNode.removeChild(extras[i]);
      var cur = media.getAttribute('data-wx-src') || '';
      if (cur === kind) return;
      if (!cur) { originalNodes = document.createDocumentFragment(); while (media.firstChild) originalNodes.appendChild(media.firstChild); }
      else { while (media.firstChild) media.removeChild(media.firstChild); }
      if (kind) {
        media.className = 'lds-h__feature-media lds-h__feature-media--' + kind;
        media.appendChild(tpl(kind));
        media.setAttribute('data-wx-src', kind);
      } else {
        media.className = served.cls;
        if (originalNodes) media.appendChild(originalNodes);
        originalNodes = null;
        media.removeAttribute('data-wx-src');
      }
    }
    function addExtra(name) {
      var frag = tpl(name);
      if (!frag) return null;
      var el = frag.firstElementChild;
      if (el) { el.setAttribute('data-wx-extra', ''); media.appendChild(el); }
      return el;
    }
    function fill(s, f) {
      return String(s || '').replace(/\[temp\]/g, deg(f.t7)).replace(/\[high\]/g, f.high === null ? '' : deg(f.high))
        .replace(/\[feels\]/g, deg(f.feels)).replace(/\[city\]/g, f.city)
        .replace(/\[when\]/g, f.today ? cfg.words.thisMorning : cfg.words.tomorrow)
        .replace(/\[afternoon\]/g, f.today ? cfg.words.thisAfternoon : cfg.words.tomorrowAfternoon);
    }
    function served_() {
      setMedia('');
      tag.textContent = served.tag; title.textContent = served.title; text.textContent = served.text;
      btn.textContent = served.btn; btn.setAttribute('href', served.href);
      root.removeAttribute('data-wx-mode');
      if (strip) strip.hidden = true;
      if (credit) credit.hidden = true;
      if (also) also.setAttribute('data-wx-show', 'theft');
    }

    function apply(f) {
      var mode = pickMode(f, cfg), c = cfg.copy[mode];
      if (!c) return;
      var near = f.lat === null || f.lon === null || km(cfg.shop[0], cfg.shop[1], f.lat, f.lon) <= cfg.radius;
      setMedia(mode === 'mild' ? 'tiles' : mode === 'hot' && cfg.hasHot ? 'hot' : '');
      if (mode === 'snow') addExtra('snow');
      if (mode === 'cold' && f.t7 <= 0) addExtra('frost');
      if (mode === 'hot') addExtra('heat');
      if (mode !== 'mild') {
        var b = addExtra('badge');
        if (b) {
          b.className += ' lds-wx--' + mode;
          b.querySelector('[data-wx-badge-temp]').textContent = mode === 'hot' ? deg(f.high) : deg(f.t7);
          b.querySelector('[data-wx-badge-when]').textContent = fill(c.badge, f);
          var extra = mode === 'snow' ? cfg.words.snowLine : (mode === 'cold' && f.feels <= f.t7 - 2 ? fill(cfg.words.feelsLine, f) : '');
          var line = b.querySelector('[data-wx-badge-line]');
          line.textContent = extra; line.hidden = !extra;
        }
      }
      if (mode === 'snow' && !reduce) {
        var flakes = media.querySelector('.lds-wx-flakes');
        if (flakes && !flakes.firstChild) {
          for (var i = 0; i < 26; i++) {
            var fl = document.createElement('i'), s = (2 + Math.random() * 4).toFixed(1);
            fl.style.cssText = 'left:' + (Math.random() * 100).toFixed(1) + '%;width:' + s + 'px;height:' + s + 'px;animation-duration:' + (4 + Math.random() * 5).toFixed(1) + 's;animation-delay:-' + (Math.random() * 8).toFixed(1) + 's';
            flakes.appendChild(fl);
          }
        }
      }
      tag.textContent = mode === 'cold' && f.t7 <= 0 ? c.tagFreezing : c.tag;
      title.textContent = fill(c.heading, f);
      text.textContent = fill(c.text, f) + (mode === 'mild' ? '' : ' ' + (near ? cfg.installLine : cfg.shipLine));
      btn.textContent = c.button;
      btn.setAttribute('href', c.link);
      if (strip) {
        strip.hidden = mode === 'mild';
        if (mode !== 'mild') {
          strip.className = 'lds-wx-strip lds-wx--' + mode;
          strip.setAttribute('href', c.link);
          strip.querySelector('[data-wx-strip-temp]').textContent = mode === 'hot' ? deg(f.high) : deg(f.t7);
          strip.querySelector('[data-wx-strip-text]').textContent = fill(c.strip, f);
        }
      }
      if (also) also.setAttribute('data-wx-show', mode === 'mild' ? 'rs' : 'theft');
      if (credit) { credit.hidden = false; var cc = q('[data-wx-city]'); if (cc) cc.textContent = f.city; }
      root.setAttribute('data-wx-mode', mode);
      try { window.Shopify.analytics.publish('lds_hero_weather', { mode: mode, city: f.city }); } catch (e) {}
    }
    function load(id) { return getForecast(id).then(apply, served_); }

    /* Change city: type a few letters, pick from Environment Canada's 844 forecast locations. */
    var box = q('[data-wx-pick]'), input = q('[data-wx-pick-input]'), list = q('[data-wx-pick-list]'), toggle = q('[data-wx-change]');
    if (box && input && list && toggle) {
      var open = function (yes) { box.hidden = !yes; toggle.setAttribute('aria-expanded', String(yes)); if (yes) input.focus(); else { input.value = ''; list.textContent = ''; } };
      toggle.addEventListener('click', function () { open(box.hidden); });
      box.addEventListener('keydown', function (e) { if (e.key === 'Escape') { open(false); toggle.focus(); } });
      var close = q('[data-wx-pick-close]');
      if (close) close.addEventListener('click', function () { open(false); toggle.focus(); });
      input.addEventListener('input', function () {
        var term = plain(input.value.trim());
        list.textContent = '';
        if (term.length < 2) return;
        places(cfg.placesUrl).then(function (all) {
          if (plain(input.value.trim()) !== term) return;
          var starts = [], has = [];
          all.forEach(function (p) { var n = plain(p.name), at = n.indexOf(term); if (at === 0) starts.push(p); else if (at > 0) has.push(p); });
          var hits = starts.concat(has).slice(0, 8);
          list.textContent = '';
          if (!hits.length) { var li = document.createElement('li'); li.className = 'lds-wx-pick__none'; li.textContent = cfg.words.noMatch; list.appendChild(li); return; }
          hits.forEach(function (p) {
            var li = document.createElement('li'), b = document.createElement('button');
            b.type = 'button'; b.textContent = p.name + ', ' + p.prov;
            b.addEventListener('click', function () { store(CITY_KEY, { id: p.id, name: p.name }); open(false); toggle.focus(); load(p.id); });
            li.appendChild(b); list.appendChild(li);
          });
        }, function () {});
      });
    }

    /* Theme editor only: show one look on sample numbers. */
    var SAMPLE = { cold: { t7: -8, feels: -14, high: -2, snow: false }, snow: { t7: -3, feels: -3, high: 0, snow: true },
      hot: { t7: 21, feels: 21, high: 31, snow: false }, mild: { t7: 12, feels: 12, high: 17, snow: false } };
    if (cfg.preview && SAMPLE[cfg.preview]) {
      var s = SAMPLE[cfg.preview];
      apply({ t7: s.t7, feels: s.feels, high: s.high, snow: s.snow, today: false, city: cfg.previewCity, lat: null, lon: null });
      return;
    }

    /* Which forecast: the city this visitor picked, then their saved address, then the shop's area. */
    var picked = store(CITY_KEY);
    if (picked && picked.id) { load(picked.id); return; }
    if (!cfg.customerCity) { load(cfg.defaultId); return; }
    places(cfg.placesUrl).then(function (all) {
      var want = plain(cfg.customerCity), prov = String(cfg.customerProv || '').toLowerCase(), id = null;
      all.some(function (p) { if (plain(p.name) === want && (!prov || p.id.indexOf(prov + '-') === 0)) { id = p.id; return true; } return false; });
      load(id || cfg.defaultId);
    }, function () { load(cfg.defaultId); });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-wx-root]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
